function nkPill(pill) {
  if (pill.classList.contains('nk-soldout')) return;
  var card = pill.closest('.nk-card');

  card.querySelectorAll('.nk-card__pill').forEach(function(p) { p.classList.remove('nk-active'); });
  pill.classList.add('nk-active');

  var price = parseInt(pill.dataset.price, 10);
  var cmp   = parseInt(pill.dataset.compare, 10) || 0;
  var avail = pill.dataset.avail === 'true';
  var vid   = pill.dataset.vid;

  var nowEl  = card.querySelector('.js-nknow');
  var wasEl  = card.querySelector('.js-nkwas');
  var discEl = card.querySelector('.js-nkdisc');
  var atc    = card.querySelector('.js-nkatc');

  if (nowEl) nowEl.innerHTML = nkMoney(price);

  if (cmp && cmp > price) {
    var pct = Math.floor((cmp - price) * 100 / cmp);
    if (wasEl)  { wasEl.style.display  = ''; wasEl.innerHTML  = nkMoney(cmp); }
    if (discEl) { discEl.style.display = ''; discEl.textContent = pct + '% OFF'; }
  } else {
    if (wasEl)  wasEl.style.display  = 'none';
    if (discEl) discEl.style.display = 'none';
  }

  if (atc) {
    atc.dataset.vid = vid;
    if (!avail) {
      atc.disabled = true;
      atc.textContent = 'Sold out';
      atc.classList.add('nk-card__atc--sold');
    } else {
      atc.disabled = false;
      atc.textContent = atc.dataset.orig || 'Add to cart';
      atc.classList.remove('nk-card__atc--sold');
    }
  }
}

function nkMoney(cents) {
  try {
    if (window.Shopify && Shopify.formatMoney) {
      var fmt = (window.theme && theme.moneyFormat) || '₹{{amount}}';
      return Shopify.formatMoney(cents, fmt);
    }
  } catch(e) {}
  return '\u20B9' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

function nkATC(btn) {
  var vid = btn.dataset.vid;
  if (!vid) return;
  btn.disabled = true;
  btn.textContent = 'Adding\u2026';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
  })
  .then(function(r) { return r.json(); })
  .then(function(d) {
    if (d.status) throw new Error(d.description);
    btn.classList.add('nk-card__atc--ok');
    btn.textContent = 'Added \u2713';
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(function() {
      btn.classList.remove('nk-card__atc--ok');
      btn.textContent = btn.dataset.orig || 'Add to cart';
      btn.disabled = false;
    }, 1800);
  })
  .catch(function() {
    btn.textContent = 'Error \u2014 try again';
    btn.disabled = false;
  });
}